module.exports = __webpack_public_path__ + "img/poster8.d8ed6195.jpg";